export default "__VITE_ASSET__CJvEC$P$__"